
import React, { useState } from 'react';
function DigitalMarket() {
  const [activeAccordion, setActiveAccordion] = useState('collapseOne');

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? '' : id);
  };

  return (
    <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Digital Marketing</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> 
                  <span>Digital Marketing</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Sidebar Area */}
      <div className="service-sidebar-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service2-widget-sidebar" style={{padding: '0 !important'}}>
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/service/service-img12.png" alt="" />
                </div>
                <div className="space32"></div>
                <h3>Digital Marketing</h3>
                <div className="space20"></div>
                <p>
                  Digital marketing is a rapidly growing field that involves promoting brands, products, and services online through multiple channels like social media, search engines, email, and paid ads. This makes it easier for businesses to reach their target audience, increase visibility, and drive growth effectively.
                </p>
                <div className="space14"></div>
                
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>SEO & SEM Strategies</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Social Media Marketing</b>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Content Marketing</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Email & Automation</b>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="space32"></div>
                <div className="pera-box">
                  {/* <h4>Safeguard Your Business With Advanced Cybersecurity</h4> */}
                  <div className="space12"></div>
                  <p>
                  One of the key benefits of digital marketing is data-driven decision-making. Analytics tools provide real-time insights into customer behavior, campaign performance, and ROI. This allows businesses to optimize strategies instantly instead of relying on guesswork. Digital marketing connects businesses with global audiences, drives measurable growth, and ensures better customer engagement.
                  </p>
                </div>
                
                <div className="space18"></div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img13.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img14.png" alt="" />
                    </div>
                  </div>
                </div>
                
                <div className="space32"></div>
                <h3>What We Provide</h3>
<div class="space20"></div>
<ul className="check-list">
  <li>
  <b>SEO Optimization</b> – Boost organic visibility and rankings.
</li>
<li>
  <b>Social Media Campaigns</b> – Creative strategies to grow and engage followers.
</li>
<li>
  <b>PPC Advertising</b> – Targeted ads that maximize ROI.
</li>
<li>
  <b>Content Strategy</b> – Blogs, graphics, and videos tailored for your audience.
</li>
<li>
  <b>Analytics & Reporting</b> – Actionable insights to improve performance.
</li>
<li>
  <b>Brand Strategy</b> – Build trust and recognition in your market.
</li>
<li>
  <b>Growth-Oriented Approach</b> – Strategies designed to scale your business.
</li>
</ul>


                
                <div className="space48"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalMarket
